import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const GlobeIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('GlobeIcon', className)}
  >
    <path
      d="M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9
	C21,7,17,3,12,3z"
    />
    <path d="M22,13H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h20c0.6,0,1,0.4,1,1S22.6,13,22,13z" />
    <path
      d="M12,23c-0.3,0-0.5-0.1-0.7-0.3C8.6,19.8,7.1,16,7,12c0.1-4,1.6-7.8,4.3-10.7C11.5,1.1,11.7,1,12,1l0,0
	c0.3,0,0.5,0.1,0.7,0.3C15.4,4.2,16.9,8,17,12c-0.1,4-1.6,7.8-4.3,10.7C12.5,22.9,12.3,23,12,23z M12,3.6C10.1,6,9.1,8.9,9,12
	c0.1,3,1.1,6,3,8.4c1.9-2.4,2.9-5.4,3-8.5C14.9,8.9,13.9,6,12,3.6z"
    />
  </svg>
);

export default GlobeIcon;
